module.exports = {
    // url :"https://api-dev.sensemore.io:4243"
     url :process.env.VUE_APP_APIURL
    // url :"http://localhost:3000"
   // url:'https://ugvsmcpwfd.execute-api.eu-central-1.amazonaws.com'
}